/* tslint:disable */
/* eslint-disable */
/**
 * MCP Manager API
 * API for managing Model Context Protocol (MCP) connections
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the MCPCallToolPayload interface.
 */
export function instanceOfMCPCallToolPayload(value) {
    if (!('server_id' in value) || value['server_id'] === undefined)
        return false;
    if (!('tool_name' in value) || value['tool_name'] === undefined)
        return false;
    if (!('args' in value) || value['args'] === undefined)
        return false;
    return true;
}
export function MCPCallToolPayloadFromJSON(json) {
    return MCPCallToolPayloadFromJSONTyped(json, false);
}
export function MCPCallToolPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'server_id': json['server_id'],
        'tool_name': json['tool_name'],
        'args': json['args'],
    };
}
export function MCPCallToolPayloadToJSON(json) {
    return MCPCallToolPayloadToJSONTyped(json, false);
}
export function MCPCallToolPayloadToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'server_id': value['server_id'],
        'tool_name': value['tool_name'],
        'args': value['args'],
    };
}
